import { render, staticRenderFns } from "./OurFacilityListing.vue?vue&type=template&id=befd1f24&"
import script from "./OurFacilityListing.vue?vue&type=script&lang=js&"
export * from "./OurFacilityListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports